import React from "react";
import tempConverter from './tempConverter.js';


export default function WeatherTemperature(props) {
    // const [unit, setUnit] = useState("celsius");
    
    function showF(event) {
        event.preventDefault();
        props.setUnit("fahrenheit");
    }

    function showC(event) {
        event.preventDefault();
        props.setUnit("celsius");
    }

    return (
        <div className="WeatherTemperature">
        <span className="temperature">{tempConverter(props.celsius, props.unit)}</span>  
        <span className="unit">    
        <a className="metric" href="/" onClick={showC}>°C </a> | <a className="metric" href="/" onClick={showF}>°F</a> 
        </span>
        </div>
    );
    
//     if (props.unit ==='celsius') {
//     return (
//     <div className="WeatherTemperature">
//     <span className="temperature">{Math.round(props.celsius)}</span> 
//     <span className="unit">°C | {" "} 
//     <a className="metric" href="/" onClick={showF}>F°</a></span>
//     </div>
//     );
// } else { 
//     let fahrenheit = (props.celsius * 9/5) + 32;
//     return (
//         <div className="WeatherTemperature">
//         <span className="temperature">{Math.round(fahrenheit)}</span> 
//         <span className="unit">
//         <a className="metric" href="{}" onClick={showC}>°C </a> | F° </span>
//         </div>
//         );
// }
}
